/* TWRD mobile nav (< 768 px, header setting "TWRD nav C").
   1. Tabs Shop / Help / The Word / The Club inside #modal-main-menu.
      Arrow keys, Home and End move between tabs (WAI-ARIA tabs pattern).
   2. Any link or the chat button closes the drawer first. A link to a hash on
      the same page would otherwise leave the drawer open over the page.
   Focus trap and Escape stay with the theme dialog (a11y-dialog). */
(function () {
  'use strict';

  var MODAL_ID = 'modal-main-menu';

  function closeDrawer(modal) {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    var btn = modal.querySelector('.modal__close[data-a11y-dialog-hide]');
    if (btn) {
      btn.click();
      return;
    }
    if (typeof modal.close === 'function') modal.close();
  }

  function selectTab(root, tab, moveFocus) {
    var tabs = root.querySelectorAll('[data-twrd-mnav-tab]');
    var name = tab.getAttribute('data-twrd-mnav-tab');
    Array.prototype.forEach.call(tabs, function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    var drawer = root.closest('#modal-main-menu') || document;
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-twrd-mnav-cards]'), function (c) {
      c.hidden = c.getAttribute('data-twrd-mnav-cards') !== name;
      if (!c.hidden) c.scrollLeft = 0;
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-twrd-mnav-panel]'), function (p) {
      p.hidden = p.getAttribute('data-twrd-mnav-panel') !== name;
    });
    if (moveFocus) tab.focus();
  }

  function onTabKey(root, event) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-twrd-mnav-tab]'));
    var i = tabs.indexOf(event.target);
    if (i < 0) return;
    var next = null;
    if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
    else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    selectTab(root, next, true);
  }

  /* The Help and The Word card rails are hidden until their tab is tapped, so
     their lazy images only started to load on the tap and showed as empty
     cream tiles for a moment on phones (2026-10-29). Start those loads when
     the drawer opens instead. Runs once per page. */
  function warmRails(modal) {
    if (!modal || modal.dataset.twrdMnavWarm === 'true') return;
    modal.dataset.twrdMnavWarm = 'true';
    var imgs = modal.querySelectorAll('[data-twrd-mnav-cards][hidden] img[loading="lazy"]');
    Array.prototype.forEach.call(imgs, function (img) {
      img.loading = 'eager';
    });
  }

  function isPlainClick(event) {
    return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  }

  function init() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || modal.dataset.twrdMnavReady === 'true') return;
    var root = modal.querySelector('[data-twrd-mnav]');
    if (!root) return;
    modal.dataset.twrdMnavReady = 'true';

    var opener = '[data-a11y-dialog-show="' + MODAL_ID + '"]';
    function onOpenerIntent(event) {
      if (event.target.closest && event.target.closest(opener)) warmRails(modal);
    }
    document.addEventListener('pointerdown', onOpenerIntent, { passive: true });
    document.addEventListener('click', onOpenerIntent);
    root.addEventListener('pointerdown', function () { warmRails(modal); }, { passive: true });

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-twrd-mnav-tab]');
      if (tab) selectTab(root, tab, false);
    });
    root.addEventListener('keydown', function (event) {
      if (event.target.closest('[data-twrd-mnav-tab]')) onTabKey(root, event);
    });

    /* Close first, then let the browser follow the link. The chat button
       (data-twrd-chat-open) is opened by the widget's own document listener. */
    modal.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var link = event.target.closest('.twrd-mnav a[href], .twrd-mnav__util a[href], .twrd-drawer-card[href], [data-twrd-mnav-close]');
      if (!link || !modal.contains(link)) return;
      if (link.tagName === 'A' && !isPlainClick(event)) return;
      closeDrawer(modal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
